import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"
import { setValueOrEmpty } from "../lib/empty_value"

// Opens the Email Stats modal for a Win Back campaign: fetches BOTH the
// last-run and lifetime funnels (sent / delivered / bounced / opened /
// unsubscribed) fresh on every open — the delivery numbers keep changing
// as Postmark webhooks land. The Last Run / Lifetime tabs switch between
// the two already-fetched funnels client-side.
export default class extends Controller {
  static targets = [
    "modal", "title", "viewTab",
    "sent", "delivered", "bounced", "opened", "unsubscribed"
  ]

  static DEFAULT_VIEW = "last_run"

  async open(event) {
    const { url, title } = event.params
    if (this.hasTitleTarget && title) this.titleTarget.textContent = title
    this._funnels = null
    this._switchTo(this.constructor.DEFAULT_VIEW)

    // One shared modal, three campaign buttons: a slow response from an
    // earlier open must not land under a later open's title.
    const token = (this._openToken = (this._openToken || 0) + 1)

    this._show()

    try {
      const response = await get(url, { responseKind: "json" })
      if (!response.ok || token !== this._openToken) return
      const data = await response.json
      if (token !== this._openToken) return
      this._funnels = data.ran ? data : null
      this._render()
    } catch {
      // leave placeholders — transient fetch error
    }
  }

  switchView(event) {
    this._switchTo(event.params.view)
  }

  _switchTo(view) {
    this._view = view
    this.viewTabTargets.forEach((tab) => {
      const selected = tab.dataset.winbackStatsViewParam === view
      tab.classList.toggle("active", selected)
      tab.setAttribute("aria-selected", selected ? "true" : "false")
    })
    this._render()
  }

  _show() {
    if (!this.hasModalTarget) return
    const modal = window.bootstrap?.Modal?.getOrCreateInstance(this.modalTarget)
    if (modal) modal.show()
  }

  _render() {
    this._fill(this._funnels?.[this._view] || {})
  }

  _fill(stats) {
    const display = (value) => (value === undefined || value === null ? null : value.toLocaleString())
    if (this.hasSentTarget) setValueOrEmpty(this.sentTarget, display(stats.sent))
    if (this.hasDeliveredTarget) setValueOrEmpty(this.deliveredTarget, display(stats.delivered))
    if (this.hasBouncedTarget) setValueOrEmpty(this.bouncedTarget, display(stats.bounced))
    if (this.hasOpenedTarget) setValueOrEmpty(this.openedTarget, display(stats.opened))
    if (this.hasUnsubscribedTarget) setValueOrEmpty(this.unsubscribedTarget, display(stats.unsubscribed))
  }
}
